import { IconButton } from "@mui/material";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import MDBox from "components/MDBox";
import FilterBar from "examples/FilterBar/FilterBar";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Delete } from "@mui/icons-material";

import { useDispatch, useSelector } from "react-redux";
import DeleteDialog from "components/DeleteDialogBox/DeleteDialog";
import AddPayemntDialogContent from "./AddPayemntDialogContent";
import { deleteOrder, getOrdersList } from "../Redux/actionCreator";
import { getOrders } from "services/transactionServices";
import { useEffect } from "react";

const Payments = () => {
  const { state } = useLocation();
  const dispatch = useDispatch();

  const handleDelete = (ID) => {
    dispatch(deleteOrder(ID));
  };

  const columns = [
    {
      field: "_id",
      headerName: `ID`,
      renderCell: (cellValues) => {
        const rowID = cellValues?.row?._id;
        return <Link to={`${rowID}`}>{rowID}</Link>;
      },
      flex: 1.2,
    },
    {
      field: "currency",
      headerName: `Currency`,
      renderCell: (cellValues) => {
        const currency = cellValues?.row?.currency;
        return currency;
      },
      flex: 1.2,
    },
    {
      field: "status",
      headerName: `Status`,
      renderCell: (cellValues) => {
        const status = cellValues?.row?.status;
        return status;
      },
      flex: 1.2,
    },
    {
      field: "amount",
      headerName: `Amount`,
      renderCell: (cellValues) => {
        const amount = cellValues?.row?.amount;
        return amount;
      },
      flex: 1.2,
    },
    {
      field: "user",
      headerName: `User Name`,
      renderCell: (cellValues) => {
        const user = cellValues?.row?.user?.name?.full;
        return user;
      },
      flex: 1.2,
    },
    {
      field: "Delete",
      headerName: "Delete",
      renderCell: ({ row }) => (
        <>
          {" "}
          <DeleteDialog
            message={`Are you sure you want to delete ${row?._id}?`}
            handleConfirmation={() => {
              handleDelete(row._id);
            }}
            render={(handlePopupOpen) => (
              <IconButton
                aria-label="delete"
                size="small"
                // disabled={editDeleteVisibility}
              >
                {" "}
                <Delete fontSize="small" onClick={handlePopupOpen} />{" "}
              </IconButton>
            )}
          />{" "}
        </>
      ),
      sortable: false,
      flex: 1,
    },
  ];
  const rows = [
    {
      _id: "63bd34d8c6bfd50558b466bb",
      status: "paid",
      currency: "INR",
      amount_paid: 0,
      user: {
        name: {
          salutation: "Mrs",
          first: "Divya",
          middle: "",
          full: "Divya H1",
          last: "",
        },
        _id: "61a609857490a24f85fd59af",
      },
      permanentJobId: "63bd34d8c6bfd50558b466b2",
      amount: 300,
      createdAt: 1673344216197,
      updatedAt: 1673344216197,
      receipt: "create permanent job post",
      OrderId: "order_L2QmXLeJjef4mz",
      amount_due: 300,
      ordercreated_at: 1673344216,
    },
  ];

  const [isOpen, setisOpen] = useState(false);
  useEffect(() => {
    if (state?.data) {
      setisOpen(true);
    }
  }, [state]);
  const handleDialogOpen = () => {
    setisOpen(true);
  };

  const handleDialogClose = () => {
    setisOpen(false);
  };

  const [showDeltedRecords, setShowDeletedRecords] = useState(false);
  const [deletedRecords, setDeletedRecords] = useState([]);

  const handleDeleteApi = async (checked) => {
    if (checked) {
      setShowDeletedRecords(true);
      //API CALL for Delted Records
      const response = await getOrders(checked);

      setDeletedRecords(response?.data?.docs);
    } else {
      setShowDeletedRecords(false);
      //API CALL for Not Delted Records
      const response = await getOrders(checked);
    }
  };

  const { Transaction_Orders_Data } = useSelector(
    (state) => state.transactions
  );
  const orders = Transaction_Orders_Data?.transactionOrderInfo;

  useEffect(() => {
    dispatch(getOrdersList());
  }, []);

  function formatDate() {
    const now = new Date();
    
    const day = String(now.getDate()).padStart(2, '0');
    
    const monthNames = [
      'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
      'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
    ];
    
    const month = monthNames[now.getMonth()];
    const year = now.getFullYear();
  
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');
  
    const formattedDate = `${day} ${month} ${year}_${hours}_${minutes}_${seconds}`;
    
    return formattedDate;
}

  return (
    <DashboardLayout>
      {" "}
      <DashboardNavbar />
      <FilterBar
        title="Create Order"
        title1="Order"
        isOpen={isOpen}
        handleDialogOpen={handleDialogOpen}
        handleDialogClose={handleDialogClose}
        handleDeleteApi={handleDeleteApi}
        dialogContent={
          <AddPayemntDialogContent handleDialogClose={handleDialogClose} />
        }
      />{" "}
      <MDBox sx={{ marginTop: "2rem" }}>
        {" "}
        <DataGrid
          getRowId={(row) => row._id}
          components={{ Toolbar: GridToolbar }}
          componentsProps={{
            toolbar: {
              showQuickFilter: true,
              quickFilterProps: { debounceMs: 500 },
              printOptions: { disableToolbarButton: true },
              csvOptions: {
                fileName: `Orders-${formatDate()}`,
              },
            },
          }}
          columns={columns}
          rows={showDeltedRecords ? deletedRecords : [...orders].reverse()}
          pagination
          pageSize={100}
          rowsPerPageOptions={[100]}
          //isRowSelectable
          sx={{
            backgroundColor: "#ffff",
            color: "grey",
            height: "35rem",
            margin: "1rem",
            borderRadius: "0.5rem",
            "& .MuiDataGrid-cell": {
              padding: "15px",
              fontSize: "12px",
            },
            borderColor: "light-grey",
            "& .MuiDataGrid-cell:hover": {
              color: "info",
            },
          }}
        />{" "}
      </MDBox>{" "}
    </DashboardLayout>
  );
};
export default Payments;
